import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ReferenceValueSheet } from '../models/reference-value-sheet.model';

/*** Clear State. ***/
export const clearRefValSheetState = createAction('[ReferenceValueSheet] Clear RefValSheet State');

/*** Load Data. ***/
export const loadRefValSheetData = createAction('[ReferenceValueSheet] Load RefValSheet data');
export const loadStandardRefValSheetData = createAction(
  '[ReferenceValueSheet] Load Standard RefValSheet data',
);
export const loadRefValSheetsRequest = createAction(
  '[ReferenceValueSheet] Load RefValSheets request',
);
export const loadRefValSheetsSuccess = createAction(
  '[ReferenceValueSheet] Load RefValSheets success',
  props<{ refValSheets: ReferenceValueSheet[] }>(),
);
export const loadRefValSheetsError = createAction(
  '[ReferenceValueSheet] Load RefValSheets error',
  props<{ error: HttpErrorResponse }>(),
);
export const loadStandardRefValSheetsByCountryRequest = createAction(
  '[ReferenceValueSheet] Load RefValSheets by country of the location request',
);
export const loadStandardRefValSheetsByCountrySuccess = createAction(
  '[ReferenceValueSheet] Load RefValSheets by country of the location succes',
  props<{ refValSheets: ReferenceValueSheet[] }>(),
);
export const loadStandardRefValSheetsByCountryFailed = createAction(
  '[ReferenceValueSheet] Load RefValSheets by country of the location failed',
  props<{ error: HttpErrorResponse }>(),
);
export const loadColumnSettings = createAction('[ReferenceValueSheet] Load Column Settings');
export const loadStandardRefValSheetsRequest = createAction(
  '[ReferenceValueSheet] Load Standard RefValSheets request',
);

/*** Upsert Actions. ***/
export const upsertRefValSheetRequest = createAction(
  '[ReferenceValueSheet] Upsert RefValSheet request',
  props<{ refValSheet: ReferenceValueSheet; upsertType: string }>(),
);
export const upsertRefValSheetSuccess = createAction(
  '[ReferenceValueSheet] Upsert RefValSheet success',
  props<{ refValSheet: ReferenceValueSheet; upsertType: string }>(),
);
export const upsertRefValSheetError = createAction(
  '[ReferenceValueSheet] Upsert RefValSheet error',
  props<{ error: HttpErrorResponse }>(),
);

export const setColumnSettings = createAction(
  '[ReferenceValueSheet] Set Columns Settings',
  props<{ value: string[]; save: boolean }>(),
);

/*** Navigation Actions. ***/
export const createFromStandardRefValSheetNavigation = createAction(
  '[ReferenceValueSheet] Create from Standard RefValSheet Navigation',
  props<{ isStandard: boolean }>(),
);

export const createRefValSheetNavigation = createAction(
  '[ReferenceValueSheet] Create RefValSheet Navigation',
  props<{ isStandard: boolean }>(),
);
export const editRefValSheetNavigation = createAction(
  '[ReferenceValueSheet] Edit RefValSheet Navigation',
  props<{ isStandard: boolean; refValSheet: ReferenceValueSheet }>(),
);
export const viewRefValSheetNavigation = createAction(
  '[ReferenceValueSheet] View RefValSheet Navigation',
  props<{ isStandard: boolean; refValSheet: ReferenceValueSheet }>(),
);

/*** DELETE ***/
export const deleteRefValSheetConfirm = createAction(
  '[ReferenceValueSheet] Delete RefValSheet confirm',
  props<{ refValSheet: ReferenceValueSheet }>(),
);
export const deleteRefValSheetRequest = createAction(
  '[ReferenceValueSheet] Delete RefValSheet request',
  props<{ refValSheetId: number }>(),
);
export const deleteRefValSheetSuccess = createAction(
  '[ReferenceValueSheet] Delete RefValSheet success',
  props<{ refValSheetId: number }>(),
);
export const deleteRefValSheetError = createAction(
  '[ReferenceValueSheet] Delete RefValSheet error',
  props<{ error: HttpErrorResponse }>(),
);

/*** COUNTRY ***/
export const loadSelectedCountryRequest = createAction(
  '[ReferenceValueSheet] Load selected country request',
);
export const loadSelectedCountrySuccess = createAction(
  '[ReferenceValueSheet] Load selected country success',
  props<{ id: string }>(),
);
export const setSelectedCountryRequest = createAction(
  '[ReferenceValueSheet] Set selected country request',
  props<{ id: string }>(),
);
export const setSelectedCountrySuccess = createAction(
  '[ReferenceValueSheet] Set selected country success',
  props<{ id: string; refValSheets: ReferenceValueSheet[] }>(),
);

//*** BASE ***/
export const setBaseRefValSheetRequest = createAction(
  '[ReferenceValueSheet] Set base RefValSheet request',
  props<{ refValSheet: ReferenceValueSheet }>(),
);
export const setBaseRefValSheetSuccess = createAction(
  '[ReferenceValueSheet] Set base RefValSheet success',
  props<{ refValSheet: ReferenceValueSheet }>(),
);
export const setBaseRefValSheetFailed = createAction(
  '[ReferenceValueSheet] Set base RefValSheet failed',
  props<{ error: HttpErrorResponse }>(),
);
